import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { 
    useBlockProps, 
    RichText,
    InnerBlocks
} from '@wordpress/block-editor';
import { 
    PanelBody,
    Typography
} from '@wordpress/components';
import { getTypographyStyles } from '../../utils/typography';

registerBlockType('kanews/timeline-item', {
    title: __('Zaman Çizelgesi Öğesi', 'kanews'),
    category: 'kanews',
    parent: ['kanews/timeline'],
    attributes: {
        time: {
            type: 'string',
            default: '10:00'
        },
        timeTypography: {
            type: 'object',
            default: {
                fontFamily: '',
                fontSize: '',
                fontWeight: 'normal',
                lineHeight: '',
                letterSpacing: '',
                textTransform: 'none',
                fontStyle: 'normal',
                textDecoration: 'none'
            }
        },
        contentTypography: {
            type: 'object',
            default: {
                fontFamily: '',
                fontSize: '',
                fontWeight: 'normal',
                lineHeight: '',
                letterSpacing: '',
                textTransform: 'none',
                fontStyle: 'normal',
                textDecoration: 'none'
            }
        }
    },
    edit: ({ attributes, setAttributes }) => {
        const blockProps = useBlockProps();
        const { time, timeTypography, contentTypography } = attributes;

        // Apply typography styles
        const timeStyles = getTypographyStyles(timeTypography);
        const contentStyles = getTypographyStyles(contentTypography);

        return (
            <div {...blockProps}>
                <div className="kanews-timeline-news-item">
                    <div className="kanews-timeline-news-date">
                        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path>
                        </svg>
                        <RichText
                            tagName="span"
                            value={time}
                            onChange={(value) => setAttributes({ time: value })}
                            placeholder={__('Saat...', 'kanews')}
                            className="timeline-time-editor"
                            style={timeStyles}
                        />
                    </div>
                    <div className="kanews-timeline-news-content" style={contentStyles}>
                        <InnerBlocks
                            allowedBlocks={['core/paragraph', 'core/heading', 'core/list', 'core/image', 'core/quote']}
                            template={[
                                ['core/paragraph', { placeholder: __('İçerik ekleyin...', 'kanews') }]
                            ]}
                            renderAppender={InnerBlocks.ButtonBlockAppender}
                        />
                    </div>
                </div>
            </div>
        );
    },
    save: ({ attributes }) => {
        const blockProps = useBlockProps.save();
        const { time, timeTypography, contentTypography } = attributes;

        // Apply typography styles for save
        const timeStyles = getTypographyStyles(timeTypography);
        const contentStyles = getTypographyStyles(contentTypography);

        return (
            <div {...blockProps}>
                <div className="kanews-timeline-news-item">
                    <div className="kanews-timeline-news-date">
                        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z"></path>
                        </svg>
                        <span style={timeStyles}>{time}</span>
                    </div>
                    <div className="kanews-timeline-news-content" style={contentStyles}>
                        <InnerBlocks.Content />
                    </div>
                </div>
            </div>
        );
    }
}); 